export function searchTeams(teams, searchProjectKeyword) {
  const keyword = searchProjectKeyword.trim().toLowerCase()
  if (!keyword) return teams

  const retTeams = []

  teams.forEach(team => {
    const projects = team.projects.filter(
      project => project.title.toLowerCase().includes(keyword))

    if (projects.length) {
      retTeams.push({...team, projects})
    }
  })
  return retTeams
}



// WEBPACK FOOTER //
// ./src/Lib/SearchProjects.js